// src/api/lock.js
import { resolveBase } from "./config";

export async function chat({ prompt, model = "gpt-4o-mini", temperature = 0 }) {
  const base = resolveBase("lock");
  if (!base) throw new Error("Lock API not configured");

  const body = {
    prompt,
    model,
    temperature,
  };

  try {
    const res = await fetch(`${base}/demo/run`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Lock chat ${res.status}${text ? `: ${text}` : ""}`);
    }

    const data = await res.json();

    // Return the response in expected format
    return {
      text: data.text || data.response || "",
      trace: data.trace || null,
    };
  } catch (e) {
    throw new Error(`Lock chat failed: ${e.message}`);
  }
}

export async function lockHealth() {
  const base = resolveBase("lock");
  if (!base) throw new Error("Lock API not configured");
  const r = await fetch(`${base}/health`, { credentials: "omit" });
  if (!r.ok) throw new Error("lock health");
  return r.json();
}
